/**
 * List of countries code
 * ISO 3 format
 */
export const countryList: string[] = [
  "GRC",
  "MOZ",
  "MUS",
  "BWA",
  "CAF",
  "FIN",
  "KAZ",
  "FRA",
  "MHL",
  "MNE",
  "MYS",
  "NPL",
  "NZL",
  "PER",
  "USA",
  "YEM",
  "CMR",
  "CUB",
  "DOM",
  "ITA",
  "LBR",
  "SWE",
  "TUN",
  "WSM",
  "CUW",
  "DNK",
  "IDN",
  "SGP",
  "SLV",
  "UGA",
  "URY",
  "VEN",
  "DEU",
  "GUM",
  "MKD",
  "MWI",
  "PAK",
  "PRT",
  "BEL",
  "BOL",
  "COM",
  "CHE",
  "GHA",
  "IRN",
  "IRQ",
  "JAM",
  "NLD",
  "POL",
  "VAT",
  "AFG",
  "DZA",
  "HKG",
  "LAO",
  "NRU",
  "TKM",
  "ZMB",
  "AUS",
  "BHS",
  "BIH",
  "CZE",

  "KOR",
  "PHL",
  "VCT",
  "ARM",
  "AZE",
  "BDI",
  "BGD",
  "ECU",
  "ETH",
  "GAB",
  "GMB",
  "HTI",
  "KIR",
  "MAC",
  "MMR",
  "PRI",
  "QAT",
  "SVK",
  "TGO",
  "UKR",
  "CAN",
  "MLI",
  "MNP",
  "SDN",
  "BRB",
  "FJI",
  "KGZ",
  "MAF",
  "MRT",
  "ZWE",
  "CA-QC",
  "CHL",
  "HRV",
  "SAU",
  "ASM",
  "BMU",
  "COD",
  "CRI",
  "GIN",
  "IMN",
  "JPN",
  "SLB",
  "SMR",
  "SUR",
  "TCA",
  "ATG",
  "COG",
  "HND",
  "KNA",
  "ROU",
  "STP",
  "ZAF",
  "BGR",
  "BRN",
  "CYP",
  "FSM",
  "MAR",
  "MDA",
  "MDG",
  "MNG",
  "SLE",
  "TLS",
  "VNM",
  "AGO",
  "BLZ",
  "HUN",
  "IRL",
  "KWT",
  "MDV",
  "NER",
  "NIC",
  "PSE",
  "TWN",
  "ARG",
  "COL",
  "JOR",
  "NAM",
  "SRB",
  "TJK",
  "CPV",
  "GEO",
  "KOS",
  "LUX",
  "OMN",
  "RUS",
  "SOM",
  "SYC",
  "TCD",
  "TUV",
  "AND",
  "BHR",
  "BRA",
  "DJI",
  "DMA",
  "EST",
  "GTM",
  "ISR",
  "MCO",
  "MLT",
  "SEN",
  "SXM",
  "VUT",
  "ABW",
  "BEN",
  "BLR",
  "CYM",
  "GIB",
  "GNB",
  "GRD",
  "IND",
  "LBY",
  "LCA",
  "LVA",
  "PRK",
  "SSD",
  "TTO",
  "ALB",
  "BTN",
  "CIV",
  "LKA",
  "PAN",
  "SYR",
  "UZB",
  "AUT",
  "EGY",
  "ERI",
  "FRO",
  "GNQ",
  "GRL",
  "GUY",
  "LTU",
  "MEX",
  "NOR",
  "RWA",
  "SWZ",
  "THA",
  "ARE",
  "ESP",
  "GBR",
  "ISL",
  "KEN",
  "LSO",
  "NGA",
  "PLW",
  "PNG",
  "BFA",
  "CHN",
  "KHM",
  "LBN",
  "LIE",
  "PRY",
  "SVN",
  "TON",
  "TUR",
  "TZA",
  "VGB",
];

export const countryFavorites: string[] = ["FRA"];
